var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.amount != 0)?_c('button',_vm._g(_vm._b({staticClass:"retenidoBtn",on:{"click":function($event){return _vm.$emit('click')}}},'button',_vm.attrs,false),_vm.on),[_vm._v("\n  Saldo retenido $ "+_vm._s(_vm.amount)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }